import React, { useContext, useState } from 'react';
import Button from 'antd/lib/button';
import { BuyContext } from './Workflow';
import { ModelContext } from './metadata/ModelSource';
import { ApplicationActionsContext } from './data/ApplicationDataSource';
import { navigate, navigateWithData } from '../navigation/navigationHistory';
import {ConfigContext} from 'portal-core/components/PortalApp';

export const BuyNextButton = () => {
  const {
    state,
    setState,
    paymentRequest,
    navigateToStep,
    currentStep,
    isValid,
    next,
    moveTo,
    steps,
  } = useContext(BuyContext);
  const applicationModel = useContext(ModelContext);
  const { convertToQuote,saveApplication } = useContext(ApplicationActionsContext);
  const [isLoading, setIsLoading] = useState(false);

  const config = useContext(ConfigContext);
  const quoteAdvanceText = config.branding.buttons.quoteAdvance ? config.branding.buttons.quoteAdvance : 'Buy';

  const {
    systemId,
    basicPolicy: { writtenPremiumAmt: premium },
  } = applicationModel.data;

  const convertToQuoteAction = () => {
    convertToQuote().then((app) => {
      navigate(`/application/${app.systemId}`);
    });
  };

  if (currentStep === steps.length - 1) {
    return (
      <Button
        loading={isLoading}
        type="primary"
        onClick={() => {
          setIsLoading(true);
            saveApplication().then(()=>{
              navigateWithData('/consumer-consent', {
                model: applicationModel.data,
                actionData: {
                  execute: 'convertToQuote',
                  arguments: [applicationModel.data.systemId, applicationModel.data.typeCd, 0, [0, 0]],
                },
              }).then(() => {
                scrollTo(0, 0);
                setIsLoading(false);
              });
            });
        }}
        disabled={!isValid}
        id={'buyButton'}
      >
        {quoteAdvanceText}
      </Button>
    );
  }

  return (
    <Button
      type="primary"
      onClick={next}
      loading={state.loadingNext}
      disabled={!isValid}
      id={'nextButton'}
    >
      Next
    </Button>
  );
};